import { gql } from '@apollo/client';

const GET_REGIONS = gql`
  query regions {
    regions {
      id
      name
      countries # Assuming countries is a JSON string or list of strings
    }
  }
`;

export { GET_REGIONS };
export default GET_REGIONS;

// Add other Settings-related queries here if needed
